import { QuoteRequest } from "api/graphql/generated";

import { useLtlRequestQuoteSelector, useSelectQuoteRequest } from "../store/ltlState";

const useQuoteRequestValidation = (
  validator: (quoteRequest: Partial<QuoteRequest>, enableApiAutoPricing: boolean | undefined) => boolean
): { isValid: boolean } => {
  const quoteRequest = useSelectQuoteRequest();
  const enableApiAutoPricing = useLtlRequestQuoteSelector((state) => state.ltlStepSlice.enableApiAutoPricing);

  const isValid = validator(quoteRequest, enableApiAutoPricing);

  return { isValid };
};

export default useQuoteRequestValidation;
